import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { MainInfoStateData } from './type';

const initialState: MainInfoStateData = {
	data: {
		data: {
			abonent: { id: '', attrib_27: null, balance: '', contract_number: '' },
			currentTarif: { id: '', get_abon_sum: '', name: '', plan_comment: '' },
			tarifsList: [],
			uslugas: [],
		},
		error: null,
		message: '',
		code: '',
	},
	loading: false,
	error: null,
};

export const fetchMainInfo = createAsyncThunk('api/fetchMainInfo', (action: string) => api.fetchMainInfo(action));

const mainInfoSlice = createSlice({
	name: 'mainInfo',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchMainInfo.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchMainInfo.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload;
				state.error = '';
			})
			.addCase(fetchMainInfo.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузке';
			});
	},
});

export default mainInfoSlice.reducer;
